import moment from 'moment';


//moment.locale('fr');

// Configuration to export in the App
export default (app) => {
    app.config.globalProperties.$moment = moment;
}
